import { AppView } from "../babylon/AppView";
import { Env } from "../settings/Env";
export class Scene {
    // private _listeners: ListenerItem<AuthManagerEvents>[] = [];
    constructor(appController) {
        this._isVisible = false;
        this._isPaused = false;
        // private _subscribe()
        // {
        //     this._unsubscribe();
        //     this._listeners.push(this.appController.sdk.authManager.registerListener("incompleteSessionFound", async (data) => {
        //         await this.tryToRestorePrivateShowAsync(data);
        //     }));
        // }
        //
        // private _unsubscribe()
        // {
        //     this.appController.sdk.authManager.unregisterListeners(this._listeners);
        // }
        this.isManualFadeIn = false;
        this.appController = appController;
        // this.appController.sdk.authManager.registerListener("incompleteSessionFound", this.tryToRestorePrivateShow);
        // this._subscribe(); //TODO: check if necessary
    }
    // private _tempAnimationInterval: NodeJS.Timer | null = null;
    async showAsync() {
        const appView = AppView.getInstance();
        await this.view?.showAsync();
        this._isVisible = true;
        // this._subscribe();
        await appView.animationView.preloadAnimationsAsync();
        // {   // TODO DZZ DCVR-5383: Remove!
        //     if (this._tempAnimationInterval !== null) clearInterval(this._tempAnimationInterval);
        //     this._tempAnimationInterval = setInterval(() => {
        //         appView.animationView.showAnimation("coins");
        //     }, 5000);
        // }
        if (!this.isManualFadeIn) {
            appView.fadingHelper?.startFadeIn(true);
        }
        // {
        //     setTimeout(() => {
        //         AppView.getInstance().appController.notificationCenter?.showMessage(MessageType.info, "Test info message");
        //     }, 5000);
        //     setTimeout(() => {
        //         AppView.getInstance().appController.notificationCenter?.showMessage(MessageType.warning, "Test warn message");
        //     }, 6000);
        //     setTimeout(() => {
        //         AppView.getInstance().appController.notificationCenter?.showMessage(MessageType.error, "Test error message");
        //     }, 7000);
        // }
    }
    async hideAsync() {
        const appView = AppView.getInstance();
        await appView.fadingHelper?.fadeOutAsync(true);
        // {   // TODO DZZ DCVR-5383: Remove!
        //     if (this._tempAnimationInterval !== null) clearInterval(this._tempAnimationInterval);
        //     appView.animationView.hideAnimation("coins");
        // }
        this._isVisible = false;
        await this.view?.hideAsync();
        // this._unsubscribe();
    }
    async pauseAsync() {
        this._isPaused = true;
    }
    async resumeAsync() {
        this._isPaused = false;
    }
    async attachViewAsync(view) {
        if (view === this.view)
            return;
        await this.view?.hideAsync();
        this.view = view;
        if (this.view) {
            await this.initViewCallbacksAsync(this.view);
        }
        if (this._isVisible) {
            await this.showAsync();
        }
        else {
            await this.hideAsync();
        }
    }
    get isVisible() {
        return this._isVisible;
    }
    get isActivePrivateShow() {
        return false;
    }
    get isActiveSpyMode() {
        return false;
    }
    get isPaused() {
        return this._isPaused;
    }
}
Scene._RELOAD_INTERVAL_MILLIS = Env.lobby.gallery.reloadIntervalMs;
